<!--modal popup to show the service details which is provide by the support worker-->
<ion-toolbar>
  <ion-title class="ion-text-wrap"
    ><strong>{{ serviceName }}</strong></ion-title
  >

  <ion-buttons slot="end">
    <mable-button
      category="icon-only"
      icon="close"
      ariaLabel="Close"
      (onClick)="closeModal()"
      color="purple-500"
    ></mable-button>
  </ion-buttons>
</ion-toolbar>

<div class="ion-padding">
  <p
    *ngIf="information?.definition"
    [innerHTML]="information.definition"
  ></p>
  <p
    *ngIf="information?.additionalText"
    [innerHTML]="information.additionalText"
  ></p>

  <ng-container *ngIf="dialog">
    <p
      *ngFor="let desc of dialog"
      [innerHTML]="desc"
    ></p>
  </ng-container>

  <mable-button
    expand="block"
    (onClick)="closeModal()"
    class="ion-margin-top"
  >
    I understand
  </mable-button>
</div>
